import { API_BASE_URL } from "../config"

async function parseError(response: Response) {
  try {
    const payload = await response.json()
    return payload.detalle || "Ocurrió un error inesperado."
  } catch {
    return "Ocurrió un error inesperado."
  }
}

export type AdminRequestQueueItem = {
  id: number
  tracking_id: string
  beneficio: string
  fecha_solicitud: string
  estado: string
  afiliado_nombre: string
  afiliado_identificacion: string
}

export type AdminRequestDetail = {
  id: number
  tracking_id: string
  beneficio: string
  estado: string
  descripcion: string
  fecha_solicitud: string
  afiliado: {
    nombre: string
    identificacion: string
    nss: string
    telefono: string
    direccion: string
    ciudad: string
    provincia: string
  }
  empleos: {
    empresa: string
    cargo: string
    salario: string
    inicio: string
    fin: string | null
    activo: boolean
  }[]
  cotizaciones: {
    fecha: string
    monto_total: string
    empleado: string
    empleador: string
    empresa: string
  }[]
  archivos: {
    id: number
    file_name: string
    file_url: string
    file_size: string
  }[]
}

export async function fetchAdminRequestQueue(token: string, statusFilter?: string): Promise<AdminRequestQueueItem[]> {
  const url = new URL(`${API_BASE_URL}/admin-api/requests/queue`)
  if (statusFilter) {
    url.searchParams.append("status", statusFilter)
  }
  const response = await fetch(url.toString(), {
    headers: {
      Authorization: `Token ${token}`,
    },
  })
  
  if (!response.ok) {
    throw new Error(await parseError(response))
  }
  
  return response.json()
}

export async function fetchAdminRequestDetails(token: string, requestId: number): Promise<AdminRequestDetail> {
  const response = await fetch(`${API_BASE_URL}/admin-api/requests/${requestId}`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  })
  
  if (!response.ok) {
    throw new Error(await parseError(response))
  }
  
  return response.json()
}

export async function updateAdminRequestStatus(token: string, requestId: number, nuevoEstado: string): Promise<{ mensaje: string, nuevo_estado: string }> {
  const response = await fetch(`${API_BASE_URL}/admin-api/requests/${requestId}/status`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
    body: JSON.stringify({ estado: nuevoEstado }),
  })
  
  if (!response.ok) {
    throw new Error(await parseError(response))
  }
  
  return response.json()
}

export async function submitAdminRequestResolution(token: string, requestId: number, decision: string, justificacion: string): Promise<{ mensaje: string, estado: string }> {
  const response = await fetch(`${API_BASE_URL}/admin-api/requests/${requestId}/resolve`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
    body: JSON.stringify({ decision, justificacion }),
  })
  
  if (!response.ok) {
    throw new Error(await parseError(response))
  }
  
  return response.json()
}
